import { render, staticRenderFns } from "./checkBoxUi.vue?vue&type=template&id=437f405f&scoped=true"
import script from "./checkBoxUi.vue?vue&type=script&lang=js"
export * from "./checkBoxUi.vue?vue&type=script&lang=js"
import style0 from "./checkBoxUi.vue?vue&type=style&index=0&id=437f405f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f405f",
  null
  
)

export default component.exports